module.exports = __webpack_public_path__ + "img/seedling_white.fc6bcef3.svg";